<script>
  import {
    faEdit,
    faEye,
    faLocationArrow,
  } from "@fortawesome/free-solid-svg-icons"
  import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
  import _isEqual from "lodash/isEqual"
  import ResponsiveTable from "@/core/components/table/ResponsiveTable"
  import Cancel from "@/domains/spl-navegantes/partials/icons/Cancel.vue"
  import Check from "@/domains/spl-navegantes/partials/icons/Check.vue"
  import Pending from "@/domains/spl-navegantes/partials/icons/Pending.vue"

  export default {
    components: {
      ResponsiveTable,
      FontAwesomeIcon,
      Check,
      Cancel,
      Pending,
    },
    data: () => ({
      faEye,
      faEdit,
      faLocationArrow,
      title: "Linhas",
      crumbs: [
        { name: "Início", path: "index" },
        { name: "Linhas", path: "lines.index" },
        {
          name: "Pontos de Seção",
          path: "lines.sectionPoints.SectionPoints",
        },
      ],
      data: [],
      loading: false,
      situacao: "",
      status: "pending",
      headers: [
        { text: "Número", value: "idpontosecao", order: true },
        { text: "Localidade", value: "nmlocalidade", order: true },
        { text: "Descrição", value: "delocalidade", order: true },
        { text: "Município", value: "nmmunicipio", order: true },
        { text: "Linhas Ativas", value: "numlinhasativas", order: true },
        { text: "Linhas Inativas", value: "numlinhasinativas", order: true },
        { text: "Situação", value: "flsituacao", order: false },
        { text: "Ações", value: "", order: false },
      ],
      currentOrder: 1,
      orderOptions: [
        {
          id: 0,
          order: { idpontosecao: "ASC" },
        },
        {
          id: 1,
          order: { idpontosecao: "DESC" },
        },
        {
          id: 2,
          order: { nmlocalidade: "ASC" },
        },
        {
          id: 3,
          order: { nmlocalidade: "DESC" },
        },
        {
          id: 4,
          order: { delocalidade: "ASC" },
        },
        {
          id: 5,
          order: { delocalidade: "DESC" },
        },
        {
          id: 6,
          order: { nmmunicipio: "ASC" },
        },
        {
          id: 7,
          order: { nmmunicipio: "DESC" },
        },
        {
            id: 8,
            order: { numlinhasativas: "ASC" },
        },
        {
            id: 9,
            order: { numlinhasativas: "DESC" },
        },
        {
            id: 10,
            order: { numlinhasinativas: "ASC" },
        },
        {
            id: 11,
            order: { numlinhasinativas: "DESC" },
        },
      ],
      pagination: {},
      page: 1,
      toBeDeleted: null,
      filters: {
        delocalidade: "",
        nmlocalidade: "",
      },
    }),
    computed: {
      order() {
        let order = this.orderOptions.find(
          (i) => i.id === this.currentOrder
        ).order
        if (order) {
          return order
        }
        return {}
      },
    },
    watch: {
      origin() {
        this.page = 1
        this.getSectionPoints()
      },
    },
    mounted() {
      this.$watch(
        () => this.$route.query,
        (q) => {
          this.page = q.page
          if (q && Object.keys(q).length > 0) {
            const filters = {
              ...(q.localidade && {
                nmlocalidade: q.localidade,
              }),
              ...(q.descricao && {
                delocalidade: `%${q.descricao}%`,
              }),
              ...(q.municipio && {
                nmmunicipio: q.municipio,
              }),
              ...(q.situacao && { flsituacao: q.situacao }),
            }
            this.getSectionPoints(filters)
          } else {
            this.getSectionPoints()
          }
        }
      )
      let query = this.$route.query
      this.page = query.page || 0
      if (query && Object.keys(query).length > 0) {
        const filters = {
          ...(query.localidade && { nmlocalidade: query.localidade }),
          ...(query.descricao && {
            delocalidade: `%${query.descricao}%`,
          }),
          ...(query.municipio && { nmmunicipio: query.municipio }),
          ...(query.situacao && { flsituacao: query.situacao }),
        }
        this.getSectionPoints(filters)
      } else {
        this.getSectionPoints()
      }
      // this.getSectionPoints();
    },
    methods: {
      getSectionPoints(filters) {
        if (filters) {
          this.filters = filters
          this.filters.flstatus = true
        }
        try {
          this.$Progress.start()
          this.status = "pending"
          this.loading = true
          this.$axios
            .post(`/api/lines/section-point/search?page=${this.page}`, {
              orderBy: this.order,
              filters: this.filters,
            })
            .then((response) => {
              this.data = response.data.data
              this.pagination = response.data
              this.pagination.data = undefined
              this.loading = false
              this.status = "finished"
              this.$Progress.finish()
            })
        } catch (e) {
          this.status = "rejected"
          this.loading = false
          this.$Progress.finish()
        }
      },
      searchLines(sectionPoint) {
        this.$router.push({
          name: "lines.regular.index",
          query: { sectionPoint: sectionPoint.idpontosecao },
        })
      },
      editSectionPoints(sectionPoint) {
        this.$router.push({
          name: "lines.sectionpoints.edit",
          params: { id: sectionPoint.idpontosecao },
        })
      },
      changePage(page) {
        if (page !== this.page) {
          this.$router.push({
            name: "lines.sectionpoints",
            query: {
              ...this.$route.query,
              page,
            },
          })
          this.page = page
          // this.getSectionPoints();
        }
      },
      dataList(data) {
        if (data.length > 0) {
          return data.map((item) => ({
            idpontosecao: item.idpontosecao,
            delocalidade: item.delocalidade,
            nmlocalidade: item.nmlocalidade,
            gelat: item.gelat,
            gelng: item.gelng,
          }))
        }
        return []
      },
      updateSorting(sort) {
        let order = this.orderOptions.find((i) => _isEqual(i.order, sort))
        if (order) {
          this.currentOrder = order.id
          this.reload()
        }
      },
      reload() {
        this.page = 1
        this.getSectionPoints()
      },
      getColorBySituation(situation) {
        if (situation === "1") {
          return "#00A86B"
        }
        if (situation === "3") {
          return "#FFA500"
        }
        return "#FF0000"
      },
    },
  }
</script>

<template>
  <div>
    <portal-target name="modals"/>
    <ResponsiveTable
      :headers="headers"
      :data="data"
      :disabled="loading"
      :pagination="pagination"
      :has-pagination="true"
      :status="status"
      :sorting="true"
      :sorted-header="order"
      @sort="updateSorting"
      @changePage="page => changePage(page)"
    >
      <template #row="props">
        <td :class="props.tdClass" class="text-xs p-3 w-1/7">
          {{ props.row.idpontosecao }}
        </td>
        <td :class="props.tdClass" class="text-xs p-3 w-2/7">
          {{ props.row.nmlocalidade }}
        </td>
        <td :class="props.tdClass" class="text-xs p-3 w-2/7">
          {{ props.row.delocalidade }}
        </td>
        <td :class="props.tdClass" class="text-xs p-3 w-2/7">
          {{ props.row.city.nmmunicipio }}
        </td>
        <td :class="props.tdClass" class="text-xs p-3 text-center">
            {{ props.row.numlinhasativas }}
        </td>

        <td :class="props.tdClass" class="text-xs p-3 text-center">
            {{ props.row.numlinhasinativas }}
        </td>
        <td
          :class="props.tdClass"
          :style="
                        `color: ${getColorBySituation(props.row.flsituacao)}`
                    "
          class="flex items-center h-full gap-2"
        >
          <div class="h-max">
            <Check v-if="props.row.flsituacao == 1"/>
            <Cancel v-if="props.row.flsituacao == 2"/>
            <Pending v-if="props.row.flsituacao == 3"/>
          </div>
          {{
            props.row.flsituacao == 1
              ? "ATIVO"
              : props.row.flsituacao == 3
              ? "AGUARDANDO AJUSTE"
              : "INATIVO"
          }}
        </td>

        <td :class="props.tdClass" class="w-1/7">
          <div class="flex items-baseline">
            <div
              class="text-green-base cursor-pointer"
              title="Editar Ponto de Seção"
              @click="editSectionPoints(props.row)"
            >
              <FontAwesomeIcon :icon="faEdit"/>
            </div>
            <div
              class="text-green-base cursor-pointer inline ml-3"
              title="Buscar linhas"
              @click="searchLines(props.row)"
            >
              <FontAwesomeIcon :icon="faLocationArrow"/>
            </div>
          </div>
        </td>
      </template>
      <template #responsive="props">
        <tr class="flex items-center py-2">
          <th
            class="w-2/5 flex-shrink-0 text-right pr-4 font-bold text-gray-700 uppercase text-xs"
          >
            Número
          </th>
          <td
            :class="[
              props.tdClass,
              'w-3/5',
              'break-words',
              'flex',
              'justify-between',
              'items-center'
            ]"
          >
            <span>{{ props.row.idpontosecao }}</span>
            <div class="flex items-baseline">
              <div
                class="text-green-base cursor-pointer"
                title="Editar Ponto de Seção"
                @click="editSectionPoints(props.row)"
              >
                <FontAwesomeIcon :icon="faEdit"></FontAwesomeIcon>
              </div>
              <div
                class="text-green-base cursor-pointer inline ml-3"
                title="Buscar linhas"
                @click="searchLines(props.row)"
              >
                <FontAwesomeIcon :icon="faLocationArrow"/>
              </div>
            </div>
          </td>
        </tr>
        <tr class="flex items-center py-2">
          <th
            class="w-2/5 flex-shrink-0 text-right pr-4 font-bold text-gray-700 uppercase text-xs"
          >
            Localidade
          </th>
          <td :class="[props.tdClass, 'w-3/5', 'break-words']">
            {{ props.row.nmlocalidade }}
          </td>
        </tr>
        <tr class="flex items-center py-2">
          <th
            class="w-2/5 flex-shrink-0 text-right pr-4 font-bold text-gray-700 uppercase text-xs"
          >
            Descrição
          </th>
          <td :class="[props.tdClass, 'w-3/5', 'break-words']">
            {{ props.row.delocalidade }}
          </td>
        </tr>
        <tr class="flex items-center py-2">
          <th
            class="w-2/5 flex-shrink-0 text-right pr-4 font-bold text-gray-700 uppercase text-xs"
          >
            Município
          </th>
          <td :class="[props.tdClass, 'w-3/5', 'break-words']">
            {{ props.row.city.nmmunicipio }}
          </td>
        </tr>
        <tr class="flex items-center py-2">
          <th
            class="w-2/5 flex-shrink-0 text-right pr-4 font-bold text-gray-700 uppercase text-xs"
          >
           Linhas Ativas
          </th>
          <td :class="[props.tdClass, 'w-3/5', 'break-words']">
            {{ props.row.numlinhasativas  }}
          </td>
        </tr>
        <tr class="flex items-center py-2">
          <th
            class="w-2/5 flex-shrink-0 text-right pr-4 font-bold text-gray-700 uppercase text-xs"
          >
           Linhas Inativas
          </th>
          <td :class="[props.tdClass, 'w-3/5', 'break-words']">
            {{ props.row.numlinhasinativas   }}
          </td>
        </tr>
        <tr class="flex items-center py-2">
          <th
            class="w-2/5 flex-shrink-0 text-right pr-4 font-bold text-gray-700 uppercase text-xs"
          >
            Situação
          </th>
          <td
            :class="[props.tdClass, 'w-3/5', 'break-words']"
            :style="`color: ${getColorBySituation(props.row.flsituacao)}`"
          >
            <div class="flex items-center h-full gap-2">
              <div class="h-max">
                <Check v-if="props.row.flsituacao == 1"/>
                <Cancel v-if="props.row.flsituacao == 2"/>
                <Pending v-if="props.row.flsituacao == 3"/>
              </div>
              {{
                props.row.flsituacao == 1
                  ? "ATIVO"
                  : props.row.flsituacao == 3
                  ? "AGUARDANDO AJUSTE"
                  : "INATIVO"
              }}
            </div>
          </td>
        </tr>
      </template>
    </ResponsiveTable>
  </div>
</template>
